import { useWidth } from "@/src-refactor/modules/shared/hooks/use-width.hook";
import { createPortal } from "react-dom";
import { Box, IconButton, styled } from "@mui/material";
import BackIcon from "@icons-rf/property-panel/arrow-back.svg?react";
import { useNavigate } from "react-router-dom";

interface MxNavBackButtonProps {
  defaultBackRoute?: string;
  requiredCloseWindow?: boolean;
}

const MxNavBackButton = ({
  defaultBackRoute = "/",
  requiredCloseWindow = false
}: MxNavBackButtonProps) => {
  const width = useWidth();
  const isMobile = ["xs", "sm"].includes(width);
  const navigate = useNavigate();

  const handleBack = () => {
    if (requiredCloseWindow) {
      const canCloseWindow =
        typeof window !== "undefined" && window.opener && !window.opener.closed;

      if (canCloseWindow) {
        window.close();
        return;
      }
    }

    navigate(defaultBackRoute, { replace: true });
  };

  return (
    <>
      {!isMobile &&
        (() => {
          const toolBar =
            typeof document !== "undefined"
              ? document.getElementById("tool-bar")
              : null;
          return toolBar
            ? createPortal(
                <NavBarButton>
                  <BackButton disableRipple onClick={handleBack} size="small">
                    <BackIcon />
                  </BackButton>
                </NavBarButton>,
                toolBar
              )
            : null;
        })()}
    </>
  );
};

export default MxNavBackButton;

const BackButton = styled(IconButton)`
  top: 10px;
  left: 10px;
`;

const NavBarButton = styled(Box)`
  position: relative;
  width: 25px;
  height: 25px;
  top: -15px;
  z-index: 10001;
  & .MuiButtonBase-root {
    background-color: var(--m-color-blue-03);
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;

    &:hover {
      background-color: var(--m-color-blue-03);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }

    svg {
      color: white;
      width: 20px;
      height: 20px;
    }
  }
`;
